// extracted by mini-css-extract-plugin
export default {"button":"css_button__CLsfT"};